import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {
  url = "services/portaleamministrazione/api"
  constructor(private httpClient: HttpClient) { }

  getToolbar(): Observable<any>{
    return this.httpClient.get<any>(this.url + "/toolbar-frontoffice?appl=PNRR");
  }
}
